import React from "react";

export interface QuestionBoxIconProps {
  fill?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

const QuestionBoxIcon: React.FC<QuestionBoxIconProps> = ({
  fill = "#E4E4E4",
  width = 18,
  height = 18,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M16.3125 8.98242C16.3125 6.38086 14.9062 3.99023 12.6562 2.6543C10.3711 1.35352 7.59375 1.35352 5.34375 2.6543C3.05859 3.99023 1.6875 6.38086 1.6875 8.98242C1.6875 11.6191 3.05859 14.0098 5.34375 15.3457C7.59375 16.6465 10.3711 16.6465 12.6562 15.3457C14.9062 14.0098 16.3125 11.6191 16.3125 8.98242ZM0 8.98242C0 5.7832 1.6875 2.83008 4.5 1.21289C7.27734 -0.404297 10.6875 -0.404297 13.5 1.21289C16.2773 2.83008 18 5.7832 18 8.98242C18 12.2168 16.2773 15.1699 13.5 16.7871C10.6875 18.4043 7.27734 18.4043 4.5 16.7871C1.6875 15.1699 0 12.2168 0 8.98242ZM5.94141 5.81836C6.22266 5.00977 6.96094 4.48242 7.80469 4.48242H9.84375C11.0742 4.48242 12.0938 5.50195 12.0938 6.73242C12.0938 7.50586 11.6367 8.24414 10.9688 8.63086L9.84375 9.29883C9.80859 9.75586 9.45703 10.1074 9 10.1074C8.50781 10.1074 8.15625 9.75586 8.15625 9.26367V8.80664C8.15625 8.49023 8.29688 8.20898 8.57812 8.06836L10.125 7.18945C10.3008 7.08398 10.4062 6.9082 10.4062 6.73242C10.4062 6.41602 10.1602 6.20508 9.84375 6.20508H7.80469C7.69922 6.20508 7.59375 6.27539 7.55859 6.38086L7.52344 6.41602C7.38281 6.87305 6.89062 7.08398 6.46875 6.94336C6.01172 6.76758 5.80078 6.27539 5.94141 5.85352V5.81836ZM7.875 12.3574C7.875 11.7598 8.36719 11.2324 9 11.2324C9.59766 11.2324 10.125 11.7598 10.125 12.3574C10.125 12.9902 9.59766 13.4824 9 13.4824C8.36719 13.4824 7.875 12.9902 7.875 12.3574Z"
        fill={fill}
      />
    </svg>
  );
};

export default QuestionBoxIcon;
